import { useEffect, useState } from "react";
import { Link, Outlet, useNavigate, useParams } from "react-router-dom";
import { createService, getParentServices, updateService, getServiceById } from "../../Services/dynamicservice";




function CreateService() {
    const { id } = useParams();   // serviceId
    const isEditMode = Boolean(id);

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    // Service fields
    const [name, setName] = useState("");
    const [slug, setSlug] = useState("");
    const [parentServiceId, setParentServiceId] = useState(null);
    const [formSchema, setFormSchema] = useState("{}");
    const [editingIndex, setEditingIndex] = useState(null);
    const [fields, setFields] = useState([]);
    const [field, setField] = useState({
        label: "",
        type: "text",
        required: false,
        options: ""
    });

    useEffect(() => {
        if (!isEditMode) return;

        const loadService = async () => {
            const service = await getServiceById(id);

            setName(service.name);
            setSlug(service.slug);
            setParentServiceId(service.parentServiceId);

            setFields(JSON.parse(service.formSchema));

            const userP = service.prices.find(p => p.userType === "USER");
            const agentP = service.prices.find(p => p.userType === "AGENT");

            setUserPrice(userP?.price || "");
            setAgentPrice(agentP?.price || "");
        };

        loadService();
    }, [id]);


    const addField = () => {
        if (!field.label) return;

        const newField = {
            id: field.label.replace(/\s+/g, "").toLowerCase(),
            label: field.label,
            type: field.type,
            required: field.required,
            placeholder: field.label,
            options:
                field.type === "select" || field.type === "radio"
                    ? field.options.split(",").map(o => o.trim())
                    : []
        };

        if (editingIndex !== null) {
            const updated = [...fields];
            updated[editingIndex] = newField;
            setFields(updated);
            setEditingIndex(null);
        } else {
            setFields([...fields, newField]);
        }

        setField({ label: "", type: "text", required: false, options: "" });
    };

    const editField = (index) => {
        const f = fields[index];
        setField({
            label: f.label,
            type: f.type,
            required: f.required,
            options: f.options?.join(",") || ""
        });
        setEditingIndex(index);
    };

    const deleteField = (index) => {
        setFields(fields.filter((_, i) => i !== index));
    };


    const moveField = (index, direction) => {
        const updated = [...fields];
        const targetIndex = direction === "up" ? index - 1 : index + 1;

        if (targetIndex < 0 || targetIndex >= updated.length) return;

        [updated[index], updated[targetIndex]] = [updated[targetIndex], updated[index]];
        setFields(updated);
    };




    // Prices
    const [userPrice, setUserPrice] = useState("");
    const [agentPrice, setAgentPrice] = useState("");

    // Parent services
    const [parentServices, setParentServices] = useState([]);

    // Load parent services
    useEffect(() => {
        getParentServices()
            .then(data => {
                console.log("Parent Services:", data);
                setParentServices(data);
            })
            .catch(err => console.error(err));
    }, []);

    const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    if (isEditMode) {
      // UPDATE
      await updateService(id, {
        name,
        slug,
        parentServiceId,
        formSchema: JSON.stringify(fields),
        userPrice: Number(userPrice),
        agentPrice: Number(agentPrice)
      });
      alert("Service updated successfully!");
    } else {
      // INSERT
      await createService({
        name,
        slug,
        parentServiceId,
        formSchema: JSON.stringify(fields),
        prices: [
          { userType: "USER", price: Number(userPrice) },
          { userType: "AGENT", price: Number(agentPrice) }
        ]
      });
      alert("Service created successfully!");
    }

    navigate("/allservices");
  } catch (err) {
    console.error(err.response?.data || err);
    alert(JSON.stringify(err.response?.data) || "Failed");
  } finally {
    setLoading(false);
  }
};




    return (
        <div>
            <div className="wrapper">
                <div className="content-page">
                    <div className="content">
                        <div className="container-fluid">

                            {/* PAGE TITLE */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box">
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item">
                                                    <Link to="/dashboard">Dashboard</Link>
                                                </li>
                                                <li className="breadcrumb-item active">Create Service</li>
                                            </ol>
                                        </div>
                                        <h4 className="page-title">
                                            {isEditMode ? "Update Service" : "Create Service"}
                                        </h4>

                                    </div>
                                </div>
                            </div>

                            {/* FORM */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">

                                            <form onSubmit={handleSubmit}>

                                                <div className="row g-2">
                                                    <div className="mb-3 col-md-6">
                                                        <label className="form-label">Service Name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={name}
                                                            onChange={e => setName(e.target.value)}
                                                            required
                                                        />
                                                    </div>

                                                    <div className="mb-3 col-md-6">
                                                        <label className="form-label">Slug</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={slug}
                                                            onChange={e => setSlug(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row g-2">
                                                    <div className="mb-3 col-md-6">
                                                        <label className="form-label">Parent Service</label>
                                                        <select
                                                            className="form-control"
                                                            value={parentServiceId ?? ""}
                                                            onChange={e => {
                                                                const value = e.target.value;
                                                                setParentServiceId(value === "" ? null : value);
                                                            }}
                                                        >
                                                            <option value="">None (Parent)</option>
                                                            {parentServices.map(service => (
                                                                <option key={service.id} value={service.id}>
                                                                    {service.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="mb-3">
                                                    <div className="card p-3 mb-3">
                                                        <h5>Form Builder</h5>
                                                        <input
                                                            className="form-control mb-2"
                                                            placeholder="Field Label"
                                                            value={field.label}
                                                            onChange={e => setField({ ...field, label: e.target.value })}
                                                        />

                                                        <select
                                                            className="form-control mb-2"
                                                            value={field.type}
                                                            onChange={e => setField({ ...field, type: e.target.value })}
                                                        >
                                                            <option value="text">Text</option>
                                                            <option value="number">Number</option>
                                                            <option value="email">Email</option>
                                                            <option value="date">Date</option>
                                                            <option value="textarea">Textarea</option>
                                                            <option value="select">Select</option>
                                                            <option value="radio">Radio</option>
                                                            <option value="checkbox">Checkbox</option>
                                                            <option value="file">File</option>
                                                        </select>

                                                        {(field.type === "select" || field.type === "radio") && (
                                                            <input
                                                                className="form-control mb-2"
                                                                placeholder="Options (comma separated)"
                                                                value={field.options}
                                                                onChange={e => setField({ ...field, options: e.target.value })}
                                                            />
                                                        )}

                                                        <div className="form-check mb-2">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                checked={field.required}
                                                                onChange={e => setField({ ...field, required: e.target.checked })}
                                                            />
                                                            <label className="form-check-label">Required</label>
                                                        </div>

                                                        <button type="button" className="btn btn-secondary" onClick={addField}>
                                                            Add Field
                                                        </button>

                                                        <div className="mb-3">
                                                            <h6>Form Preview</h6>

                                                            {fields.map((f, index) => (
                                                                <div key={f.id} className="mb-3 border rounded p-2">

                                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                                        <strong>{f.label}</strong>

                                                                        <div className="btn-group btn-group-sm">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-outline-secondary btn-sm border-0"
                                                                                title="Move up"
                                                                                onClick={() => moveField(index, "up")}
                                                                            >
                                                                                <i className="mdi mdi-arrow-up"></i>
                                                                            </button>

                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-outline-secondary btn-sm border-0"
                                                                                title="Move down"
                                                                                onClick={() => moveField(index, "down")}
                                                                            >
                                                                                <i className="mdi mdi-arrow-down"></i>
                                                                            </button>

                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-outline-primary btn-sm border-0"
                                                                                title="Edit field"
                                                                                onClick={() => editField(index)}
                                                                            >
                                                                                <i className="mdi mdi-pencil"></i>
                                                                            </button>

                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-outline-danger btn-sm border-0"
                                                                                title="Delete field"
                                                                                onClick={() => deleteField(index)}
                                                                            >
                                                                                <i className="mdi mdi-delete"></i>
                                                                            </button>

                                                                        </div>
                                                                    </div>

                                                                    {/* existing preview input stays same */}

                                                                    <label className="form-label">
                                                                        {f.label} {f.required && <span className="text-danger">*</span>}
                                                                    </label>

                                                                    {f.type === "textarea" ? (
                                                                        <textarea className="form-control" disabled />
                                                                    ) : f.type === "select" ? (
                                                                        <select className="form-control" disabled>
                                                                            <option>Select an option</option>
                                                                            {f.options.map(o => (
                                                                                <option key={o}>{o}</option>
                                                                            ))}
                                                                        </select>
                                                                    ) : f.type === "radio" ? (
                                                                        f.options.map(o => (
                                                                            <div className="form-check" key={o}>
                                                                                <input
                                                                                    type="radio"
                                                                                    className="form-check-input"
                                                                                    disabled
                                                                                />
                                                                                <label className="form-check-label">{o}</label>
                                                                            </div>
                                                                        ))
                                                                    ) : f.type === "checkbox" ? (
                                                                        <div className="form-check">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                disabled
                                                                            />
                                                                            <label className="form-check-label">{f.label}</label>
                                                                        </div>
                                                                    ) : (
                                                                        <input
                                                                            type={f.type}
                                                                            className="form-control"
                                                                            disabled
                                                                        />
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="row g-2">
                                                    <div className="mb-3 col-md-6">
                                                        <label className="form-label">User Price</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={userPrice}
                                                            onChange={e => setUserPrice(e.target.value)}
                                                            required
                                                        />
                                                    </div>

                                                    <div className="mb-3 col-md-6">
                                                        <label className="form-label">Agent Price</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={agentPrice}
                                                            onChange={e => setAgentPrice(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>

                                                <button type="submit" className="btn btn-primary" disabled={loading}>
                                                    {loading
                                                        ? "Saving..."
                                                        : isEditMode
                                                            ? "Update Service"
                                                            : "Create Service"}
                                                </button>

                                            </form>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <Outlet />
        </div>
    );
}

export default CreateService;
